import { render, staticRenderFns } from "./cascader-multiple-editor.vue?vue&type=template&id=c20658e8&scoped=true"
import script from "./cascader-multiple-editor.vue?vue&type=script&lang=js"
export * from "./cascader-multiple-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20658e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c20658e8')) {
      api.createRecord('c20658e8', component.options)
    } else {
      api.reload('c20658e8', component.options)
    }
    module.hot.accept("./cascader-multiple-editor.vue?vue&type=template&id=c20658e8&scoped=true", function () {
      api.rerender('c20658e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-cascader/cascader-multiple-editor.vue"
export default component.exports